import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const PersonSpan = styled.span`
  padding: 20px 12px;

  @media (min-width: 1220px) and (max-width: 1370px) {
    padding: 20px 10px;
  }

  @media (min-width: 1065px) and (max-width: 1219px) {
    padding: 20px 8px;
  }

  @media (min-width: 992px) and (max-width: 1064px) {
    padding: 20px 6px;
  }
`

function PersonSVG({ id, width, hexColor, percentage }) {
  const strokeWidth = "20"
  const strokeColour = hexColor
  const mask_id = "mask_" + id
  
  // Offset by 5 to ensure that the fille starts a little higher to counter the outline.
  const remainingHeight = (100 - percentage) - 5;

  return (
    <PersonSpan>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-10 -10 729 1857"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: `${width}%` }}
        version="1.0"
      >
      <mask x="0" y="0" id={mask_id}>
        <rect y={`${remainingHeight}%`} fill="white" width="100%" height={`${percentage}%`} />
      </mask>
 
        <path
          fill="transparent"
          stroke={strokeColour}
          strokeWidth={strokeWidth}
          d="M 355.00,0.21
            C 370.89,0.02 386.55,5.40 401.00,11.58
            401.00,11.58 417.00,19.09 417.00,19.09
            417.00,19.09 429.00,27.63 429.00,27.63
            438.07,34.43 443.08,38.39 450.83,47.00
            472.60,71.19 487.61,107.27 488.00,140.00
            488.41,175.78 476.71,208.04 454.49,236.00
            441.11,252.82 423.09,265.32 404.00,274.75
            386.52,283.39 359.49,288.22 340.00,288.00
            323.59,287.80 296.60,281.52 282.00,274.25
            263.54,265.04 246.64,252.92 233.32,237.00
            213.21,212.96 199.37,178.57 199.00,147.00
            198.80,129.21 201.70,113.83 207.33,97.00
            215.10,73.79 228.67,52.54 247.00,36.17
            268.54,16.94 295.66,5.06 324.00,0.21
            324.00,0.21 355.00,0.21 355.00,0.21 Z
            M 127.00,752.00
            C 127.00,752.00 127.00,947.00 127.00,947.00
            126.96,974.14 112.95,999.94 87.00,1010.55
            77.77,1014.32 77.88,1013.32 69.00,1014.17
            65.84,1014.47 64.42,1015.06 61.00,1014.82
            55.03,1014.39 47.57,1013.91 42.00,1011.91
            18.22,1003.38 0.04,979.45 0.00,954.00
            0.00,954.00 0.00,498.00 0.00,498.00
            0.03,479.89 5.89,457.76 12.60,441.00
            12.60,441.00 18.51,426.00 18.51,426.00
            34.53,393.74 63.43,363.22 95.00,345.86
            95.00,345.86 106.00,340.74 106.00,340.74
            115.35,336.23 129.99,330.30 140.00,327.90
            140.00,327.90 170.00,323.91 170.00,323.91
            170.00,323.91 182.00,323.00 182.00,323.00
            182.00,323.00 505.00,323.00 505.00,323.00
            505.00,323.00 517.00,323.91 517.00,323.91
            517.00,323.91 547.00,327.90 547.00,327.90
            557.01,330.30 571.65,336.23 581.00,340.74
            581.00,340.74 592.00,345.86 592.00,345.86
            613.41,357.63 635.87,377.50 650.49,397.00
            650.49,397.00 657.00,407.00 657.00,407.00
            661.10,413.21 665.18,419.32 668.49,426.00
            668.49,426.00 672.85,437.00 672.85,437.00
            680.49,455.04 686.97,478.33 687.00,498.00
            687.00,498.00 687.00,954.00 687.00,954.00
            686.96,979.71 667.66,1005.22 643.00,1012.56
            637.24,1014.28 636.31,1013.65 631.00,1014.17
            627.84,1014.47 626.42,1015.06 623.00,1014.82
            614.83,1014.24 607.68,1013.69 600.00,1010.55
            573.52,999.73 560.04,973.47 560.00,946.00
            560.00,946.00 560.00,552.00 560.00,552.00
            560.00,552.00 530.00,552.00 530.00,552.00
            530.00,552.00 530.00,1474.00 530.00,1474.00
            530.00,1474.00 530.00,1665.00 530.00,1665.00
            529.94,1702.71 506.08,1735.50 470.00,1746.97
            458.03,1750.78 449.31,1750.14 437.00,1750.00
            429.09,1749.90 421.31,1747.69 414.00,1744.80
            384.27,1733.02 360.05,1702.77 360.00,1670.00
            360.00,1670.00 360.00,1019.00 360.00,1019.00
            360.00,1019.00 327.00,1019.00 327.00,1019.00
            327.00,1019.00 327.00,1670.00 327.00,1670.00
            326.98,1682.93 323.96,1691.60 318.25,1703.00
            307.22,1725.00 289.66,1740.15 266.00,1747.28
            253.85,1750.94 248.34,1750.02 236.00,1750.00
            207.47,1749.96 176.90,1727.52 165.31,1702.00
            159.75,1689.75 157.02,1672.42 157.00,1659.00
            157.00,1659.00 157.00,552.00 157.00,552.00
            157.00,552.00 127.00,552.00 127.00,552.00
            127.00,552.00 127.00,752.00 127.00,752.00 Z"
        />

        <path
          fill={hexColor}
          mask={`url(#${mask_id})`}
          stroke={strokeColour}
          strokeWidth={strokeWidth}
          d="M 355.00,0.21
            C 370.89,0.02 386.55,5.40 401.00,11.58
            401.00,11.58 417.00,19.09 417.00,19.09
            417.00,19.09 429.00,27.63 429.00,27.63
            438.07,34.43 443.08,38.39 450.83,47.00
            472.60,71.19 487.61,107.27 488.00,140.00
            488.41,175.78 476.71,208.04 454.49,236.00
            441.11,252.82 423.09,265.32 404.00,274.75
            386.52,283.39 359.49,288.22 340.00,288.00
            323.59,287.80 296.60,281.52 282.00,274.25
            263.54,265.04 246.64,252.92 233.32,237.00
            213.21,212.96 199.37,178.57 199.00,147.00
            198.80,129.21 201.70,113.83 207.33,97.00
            215.10,73.79 228.67,52.54 247.00,36.17
            268.54,16.94 295.66,5.06 324.00,0.21
            324.00,0.21 355.00,0.21 355.00,0.21 Z
            M 127.00,752.00
            C 127.00,752.00 127.00,947.00 127.00,947.00
            126.96,974.14 112.95,999.94 87.00,1010.55
            77.77,1014.32 77.88,1013.32 69.00,1014.17
            65.84,1014.47 64.42,1015.06 61.00,1014.82
            55.03,1014.39 47.57,1013.91 42.00,1011.91
            18.22,1003.38 0.04,979.45 0.00,954.00
            0.00,954.00 0.00,498.00 0.00,498.00
            0.03,479.89 5.89,457.76 12.60,441.00
            12.60,441.00 18.51,426.00 18.51,426.00
            34.53,393.74 63.43,363.22 95.00,345.86
            95.00,345.86 106.00,340.74 106.00,340.74
            115.35,336.23 129.99,330.30 140.00,327.90
            140.00,327.90 170.00,323.91 170.00,323.91
            170.00,323.91 182.00,323.00 182.00,323.00
            182.00,323.00 505.00,323.00 505.00,323.00
            505.00,323.00 517.00,323.91 517.00,323.91
            517.00,323.91 547.00,327.90 547.00,327.90
            557.01,330.30 571.65,336.23 581.00,340.74
            581.00,340.74 592.00,345.86 592.00,345.86
            613.41,357.63 635.87,377.50 650.49,397.00
            650.49,397.00 657.00,407.00 657.00,407.00
            661.10,413.21 665.18,419.32 668.49,426.00
            668.49,426.00 672.85,437.00 672.85,437.00
            680.49,455.04 686.97,478.33 687.00,498.00
            687.00,498.00 687.00,954.00 687.00,954.00
            686.96,979.71 667.66,1005.22 643.00,1012.56
            637.24,1014.28 636.31,1013.65 631.00,1014.17
            627.84,1014.47 626.42,1015.06 623.00,1014.82
            614.83,1014.24 607.68,1013.69 600.00,1010.55
            573.52,999.73 560.04,973.47 560.00,946.00
            560.00,946.00 560.00,552.00 560.00,552.00
            560.00,552.00 530.00,552.00 530.00,552.00
            530.00,552.00 530.00,1474.00 530.00,1474.00
            530.00,1474.00 530.00,1665.00 530.00,1665.00
            529.94,1702.71 506.08,1735.50 470.00,1746.97
            458.03,1750.78 449.31,1750.14 437.00,1750.00
            429.09,1749.90 421.31,1747.69 414.00,1744.80
            384.27,1733.02 360.05,1702.77 360.00,1670.00
            360.00,1670.00 360.00,1019.00 360.00,1019.00
            360.00,1019.00 327.00,1019.00 327.00,1019.00
            327.00,1019.00 327.00,1670.00 327.00,1670.00
            326.98,1682.93 323.96,1691.60 318.25,1703.00
            307.22,1725.00 289.66,1740.15 266.00,1747.28
            253.85,1750.94 248.34,1750.02 236.00,1750.00
            207.47,1749.96 176.90,1727.52 165.31,1702.00
            159.75,1689.75 157.02,1672.42 157.00,1659.00
            157.00,1659.00 157.00,552.00 157.00,552.00
            157.00,552.00 127.00,552.00 127.00,552.00
            127.00,552.00 127.00,752.00 127.00,752.00 Z"
        />
      </svg>
    </PersonSpan>
  )
}

PersonSVG.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  hexColor: PropTypes.string,
  percentage: PropTypes.number.isRequired
}

PersonSVG.defaultProps = {
  hexColor: "#000000",
}
export default PersonSVG



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/PersonSVG.jsx